import { useEffect, useState } from "react";
import BenefitDetailPreview from "./form/benefit/BenefitDetailPreview";
import {getBenefit} from "../api/benefit/benefit.api";

const BenefitPreview = ({ id }) => {
  const [benefitData, setBenefitData] = useState({})

  useEffect(() => {
    getBenefit(id).then(res => {
      if (res.data) {
        setBenefitData(res.data)
      }
    })
  }, [id]);

  return (
    <div className="flex-col items-center gap-4 py-8">
      <BenefitDetailPreview benefitData={benefitData}/>
    </div>
  );
};
export default BenefitPreview;
